import identifyVisitor from '@/sdk/careshipTracking/src/collector/identifyVisitor'
import { fetchUserToken, logger } from '@/sdk/oauth'
import store from '@/store'
import axios from "axios";
import { apiUrl, requestTimeout } from "@/data/appConfig";

const getRedirectURLAndCode = (clientKey: string, clientUUID: string, redirectURL: string,response: boolean ) => {


  const url = `${apiUrl}/auth/code`;
  const queryString = {
    client_id: clientKey,
    client_uuid: clientUUID,
    redirect_uri: redirectURL,
    response_type: 'code',
    response: response
  };

  return axios.get(url, {
    timeout: requestTimeout,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    params: queryString,
    maxRedirects: 0,
    validateStatus: function (status) {
      // Accept all status codes to capture the redirect URL
      return true;
    },
  })
    .then(response => {
      if (response.status >= 300 && response.status < 400) {
        // Extract the redirect URL from the Location header
        const redirectUrl = response.headers.location;
        console.log('Redirect URL:', redirectUrl);
      } else {
        console.log('No redirect detected.');
      }
    })
    .catch(error => {
      console.error(error);        // Handle errors
    });
}

export default getRedirectURLAndCode
